<script setup lang="ts">
defineProps<{
	isActive: boolean
}>()
</script>

<template>
	<div
		class="aspect-square h-4 cursor-pointer rounded-full"
		:class="isActive == true ? 'bg-land-red' : 'bg-land-grey'"
	></div>
</template>
